import React from 'react';
import { connect } from 'react-redux';
import { Trans, withTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';

const ConsentToContactComponent = ({ i18n }: { i18n: any }) => {
  return (( i18n.exists('consentToContact.paragraph1') ?
    <Grid container>
      <Grid item xs={12}>
        <Typography paragraph={true}></Typography>
      </Grid>
      <Grid container classes={{ container: 'indent' }}>
        <Grid item xs={12}>
          <Typography variant='body2'>
            <Trans i18nKey='consentToContact.paragraph1'> </Trans>
          </Typography>
        </Grid>
      </Grid>
    </Grid> : null
  ));
};

export const ConsentToContact = connect(
  null,
)(withTranslation()(ConsentToContactComponent));
